import { get } from '../api/common';
const usageReportsApiPrefix = '/WebApi/api/UsageReports';
export const getUsageReports = async (reportType) => {
    const result = await get(`${usageReportsApiPrefix}/${reportType}`);
    if (!result.ok) {
        throw new Error(`Failed to get usage reports: ${result.statusText}`);
    }
    return result.json();
};
export const downloadUsageReport = async (reportType, reportName) => {
    const result = await get(`${usageReportsApiPrefix}/${reportType}/${reportName}`);
    if (!result.ok) {
        throw new Error(`Failed to get usage report: ${result.statusText}`);
    }
    return result.text();
};
